import React from 'react';
import { Card, Icon } from 'semantic-ui-react';
import {
  changeLabel,
  formatCount,
  formatPercent,
  formatTimestamp,
} from './utils';

const SummaryCard = ({ icon, title, value, tone, children }) => (
  <Card className={`error-summary-card ${tone || ''}`}>
    <Card.Content>
      <div className='error-summary-heading'>
        <span>{title}</span>
        <Icon name={icon} />
      </div>
      <div className='error-summary-value'>{value}</div>
      <div className='error-summary-detail'>{children}</div>
    </Card.Content>
  </Card>
);

const SummaryCards = ({ summary }) => {
  if (!summary) return null;
  const change = changeLabel(summary.change_percent);
  const businessShare =
    summary.total_failures > 0
      ? (summary.business_failure_count / summary.total_failures) * 100
      : 0;

  return (
    <Card.Group itemsPerRow={4} stackable className='error-summary-grid'>
      <SummaryCard
        icon='warning circle'
        title='失败总数'
        value={formatCount(summary.total_failures)}
        tone='danger'
      >
        <span className={`change-${change.tone}`}>{change.text}</span>
        <span>最近发生：{formatTimestamp(summary.latest_at)}</span>
      </SummaryCard>
      <SummaryCard
        icon='tags'
        title='失败组合'
        value={formatCount(summary.failure_type_count)}
        tone='orange'
      >
        <span>新增组合：{formatCount(summary.new_failure_type_count)}</span>
        <span>待归类：{formatCount(summary.unknown_failure_count)}</span>
      </SummaryCard>
      <SummaryCard
        icon='exclamation triangle'
        title='HTTP 2xx 业务失败'
        value={formatCount(summary.business_failure_count)}
        tone='yellow'
      >
        <span>占全部失败 {formatPercent(businessShare)}</span>
        <span>不能按 HTTP 成功忽略</span>
      </SummaryCard>
      <SummaryCard
        icon='crosshairs'
        title='影响范围'
        value={`${formatCount(summary.affected_model_count)} 个模型`}
        tone='blue'
      >
        <span>涉及渠道：{formatCount(summary.affected_channel_count)}</span>
        <span>统计周期内实时聚合</span>
      </SummaryCard>
    </Card.Group>
  );
};

export default SummaryCards;
